function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Statement from 'components/Statement';
import messages from '../messages';
var _React_PureComponent;
class WaitForOrganizationApprovalStatement extends (_React_PureComponent = React.PureComponent) {
    render() {
        if (!this.props.adminOrganizationMembership.isAdmin) {
            return null;
        }
        return /*#__PURE__*/ _jsx("section", {
            className: "section section--transparent",
            children: /*#__PURE__*/ _jsx(Statement, {
                headerMessage: messages.headers.waitForOrganizationApproval,
                imgSrc: "/aid/assets/svg/progress.svg",
                isFullWidth: true,
                isNoShadow: true,
                children: /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.waitForOrganizationApproval))
                })
            })
        });
    }
}
_define_property(WaitForOrganizationApprovalStatement, "propTypes", {
    // Explicit props
    adminOrganizationMembership: PropTypes.shape({
        isAdmin: PropTypes.bool.isRequired
    }).isRequired
});
export default WaitForOrganizationApprovalStatement;
